module.exports = __webpack_public_path__ + "static/media/EnergyCultivation.cdeda65c.jpg";